import { render } from "./MvtMovementList.vue?vue&type=template&id=439a8f5e"
import script from "./MvtMovementList.vue?vue&type=script&lang=js"
export * from "./MvtMovementList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__